<!-- <div id="dataLoading">Data is Loading please wait</div> -->
<!-- <input type="checkbox" id="switch" /><label for="switch">Toggle</label> -->
<!-- <app-header></app-header> -->
<app-loader id="mater"></app-loader>
<mat-tab-group preserveContent animationDuration="2000ms" mat-stretch-tabs="false" id="outerTab" (selectedTabChange)="checkAllValue($event)"
    class="matTab custom-mat-tab" (selectedIndexChange)="selectedIndexChange($event)" [selectedIndex]="selectedIndex">


    <mat-tab label="3D Model & Info">
        <div class="demomsg" *ngIf="newEmail == 'demo@ecomatrix.io'">Toggle buttons and input fields are disabled for
            demo</div>
        <div class="matContent tabBody">
            <div class="tabInnerBody">
            <div class="row">
              
                <div class="col-md-4" [innerHTML]="ebmbededCode?.embed_url | safeHtml">

                </div>

                <div class="col-md-8">
                    <div class="col-md-12 mt-4 " *ngIf='isUpdated'>


                        <mat-grid-list class="fixedTitle mt-2" cols="3" rowHeight="35px">
                            <mat-grid-tile class="newgrid">Project data access is denied</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Progress</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Approximate time will be</mat-grid-tile>

                        </mat-grid-list>
                        <mat-grid-list class="fixedTitle mt-2" cols="3" rowHeight="35px">
                            <mat-grid-tile class="newgrid color-red">Project data extrapolation is in
                                progress</mat-grid-tile>
                            <mat-grid-tile class="newgrid color-red" >{{percent}}%</mat-grid-tile>
                            <mat-grid-tile class="newgrid color-red">{{time}}&nbsp;minutes</mat-grid-tile>

                        </mat-grid-list>
                    </div>
                    <div class="col-md-12 mt-4 " *ngIf='!isProjectPresent'>
                        <mat-grid-list class="fixedTitle mt-2" cols="3" rowHeight="35px">
                            <mat-grid-tile class="newgrid color-red">There are no projects for this
                                user.</mat-grid-tile>
                        </mat-grid-list>
                    </div>
                    <div class="col-md-12 mt-4 ">

                        <mat-grid-list class="fixedTitle mt-2" cols="6" rowHeight="35px">
                            <mat-grid-tile class="newgrid">Building Area</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Wall</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Roof</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Ground Floor</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Glazing</mat-grid-tile>
                            <mat-grid-tile class="newgrid">All Floor</mat-grid-tile>
                        </mat-grid-list>
                        <mat-grid-list cols="6" rowHeight="50px">
                            <div *ngFor="let build of modval?.usrLists">
                                <mat-grid-tile> {{build.building_area}}</mat-grid-tile>
                                <mat-grid-tile> {{build.wall}}</mat-grid-tile>
                                <mat-grid-tile> {{build.roof}}</mat-grid-tile>
                                <mat-grid-tile> {{build.ground_flr}}</mat-grid-tile>
                                <mat-grid-tile> {{build.glazing}}</mat-grid-tile>
                                <mat-grid-tile> {{build.all_flrs}}</mat-grid-tile>
                            </div>
                        </mat-grid-list>
                    </div>
                    <div class="col-md-12  ">
                        <mat-grid-list class="fixedTitle  mt-2" cols="6" rowHeight="35px">
                            <mat-grid-tile class="newgrid">City</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Country</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Building/Project</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Occupancy</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Heating SP</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Cooling SP</mat-grid-tile>
                        </mat-grid-list>
                        <mat-grid-list cols="6" rowHeight="50px">
                            <div *ngFor="let build of modval?.usrLists">
                                <mat-grid-tile> {{build.city}}</mat-grid-tile>
                                <mat-grid-tile> {{build.country}}</mat-grid-tile>
                                <mat-grid-tile> {{build.build_project}}</mat-grid-tile>
                                <mat-grid-tile> {{build.occupancy}}</mat-grid-tile>
                                <mat-grid-tile> {{build.heating_sp}}</mat-grid-tile>
                                <mat-grid-tile> {{build.cooling_sp}}</mat-grid-tile>

                            </div>


                        </mat-grid-list>
                    </div>
                    <div class="col-md-12">
                        <mat-grid-list class="fixedTitle  mt-2" cols="6" rowHeight="35px">
                            <mat-grid-tile class="newgrid">Climate Information</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Heating Degree Day</mat-grid-tile>
                            <mat-grid-tile class="newgrid">Cooling Degree Day</mat-grid-tile>
                            <mat-grid-tile class="newgrid">NECB Climate Zone</mat-grid-tile>
                            <mat-grid-tile class="newgrid">ASHRAE Climate Zone</mat-grid-tile>

                        </mat-grid-list>
                        <mat-grid-list cols="6" rowHeight="50px">
                            <div *ngFor="let build of modval?.usrLists">
                                <mat-grid-tile> </mat-grid-tile>
                                <mat-grid-tile> {{build.heating_degree_day}}</mat-grid-tile>
                                <mat-grid-tile> {{build.cooling_degree_day}}</mat-grid-tile>
                                <mat-grid-tile> {{build.necb_climate_zone}}</mat-grid-tile>
                                <mat-grid-tile> {{build.ashrae_climate_zone}}</mat-grid-tile>
                            </div>


                        </mat-grid-list>


                       

                    </div>
                </div>
            </div>

            <div class="buttonStep buttonStepWithoutWizard">
                <button (click)="clickMeForward()" class="nextStepBotFirst" mat-raised-button
                    color="primary" [disabled]="isUpdated==true || isLoading==true">Next</button>
                <button (click)="clickMeForward()" class="nextStepTop" mat-raised-button
                    color="primary">Next</button>
            </div>
            
        </div>
    </div>


    </mat-tab>

    <mat-tab label="Renewables" [disabled]="isUpdated==true || isLoading==true">
        <div class="matContent tabBody">

            <div class="tabInnerBody">
            <div class="row">

                <div class="col-md-8 renewableBox">

                    <mat-grid-list id="fxdtit" class="fixedTitle " cols="2" rowHeight="35px">
                        <mat-grid-tile class="for-toggle-btn">
                            <mat-button-toggle-group #groupone="matButtonToggleGroup" value="true"
                                (change)="onValChange(groupone.value)">
                                <mat-button-toggle value="true">
                                    Yes <mat-icon>done</mat-icon>
                                </mat-button-toggle>
                                <mat-button-toggle value="false">
                                    No <mat-icon>clear</mat-icon>
                                </mat-button-toggle>
                            </mat-button-toggle-group>

                            <input [checked]="isSolarSelected==false" #groupone (change)="onTogValChange($event)"
                                type="checkbox" id="switch" [disabled]="this.newEmail == 'demo@ecomatrix.io'" /><label
                                for="switch">Toggle</label>

                        </mat-grid-tile>

                        <mat-grid-tile id="solarPV">Include Solar PV</mat-grid-tile>


                    </mat-grid-list>
                    <mat-grid-list class="fixedTitle " cols="4" rowHeight="35px">

                        <mat-grid-tile class="newgrid">Area of PV (m<sup>2</sup>)</mat-grid-tile>
                        <mat-grid-tile class="newgrid">Efficiency (%)</mat-grid-tile>
                        <mat-grid-tile class="newgrid">Azimuth (degrees)</mat-grid-tile>
                        <mat-grid-tile class="newgrid">Inclination (degrees)</mat-grid-tile>

                    </mat-grid-list>

                    <mat-grid-list cols="4" rowHeight="50px">
                        <div *ngFor="let rewnew of rewval?.solarPV">

                            <mat-grid-tile (blur)="getText($event,1,10000)" (blur)="onBlurMethodSolar()"
                                (keydown)="getDefVal($event)" id="heateng"
                                [ngClass]="{'edit_text':contentEditableRen === 'true', 'noedit_text':contentEditableRen === 'false' }"
                                attr.contenteditable="{{contentEditableRen}}" [disabled]="true">
                                {{rewnew.areaPV}}</mat-grid-tile>
                            <mat-grid-tile (blur)="getText($event,5,25)" (blur)="onBlurMethodSolar()"
                                (keydown)="getDefVal($event)" id="solarEffi"
                                [ngClass]="{'edit_text':contentEditableRen === 'true', 'noedit_text':contentEditableRen === 'false'}"
                                attr.contenteditable="{{contentEditableRen}}" [disabled]="true">
                                {{rewnew.efficiency}}</mat-grid-tile>
                            <mat-grid-tile id="solarAzi" [ngClass]="'noedit_text'"> {{rewnew.azimuth}}</mat-grid-tile>
                            <mat-grid-tile id="solarIncl" [ngClass]="'noedit_text'">
                                {{rewnew.inclination}}</mat-grid-tile>


                        </div>


                    </mat-grid-list>
                </div>
            </div> <!--end of row div -->
            <div class="row">
                <div class="col-md-8 renewableBoxWp">
                    <mat-grid-list id="fxdntt" class="fixedTitle " cols="2" rowHeight="50px">
                        <mat-grid-tile class="for-toggle-btn">
                            <mat-button-toggle-group #group="matButtonToggleGroup" value="true"
                                (change)="onWindValChange(group.value)">
                                <mat-button-toggle value="true">
                                    Yes <mat-icon>done</mat-icon>
                                </mat-button-toggle>
                                <mat-button-toggle value="false">
                                    No <mat-icon>clear</mat-icon>
                                </mat-button-toggle>
                            </mat-button-toggle-group>

                            <input [checked]="isWindSelected==false" (change)="onTogWindValChange($event)"
                                type="checkbox" id="switch1" [disabled]="this.newEmail == 'demo@ecomatrix.io'" /><label
                                for="switch1">Toggle</label>

                        </mat-grid-tile>

                        <mat-grid-tile id="windPw">Include Wind Power</mat-grid-tile>
                    </mat-grid-list>

                    <mat-grid-list class="fixedTitle " cols="4" rowHeight="35px">

                        <mat-grid-tile class="newgrid">Rated Power (kW)</mat-grid-tile>
                        <mat-grid-tile class="newgrid" [colspan]="3">Hub Height (meter)</mat-grid-tile>


                    </mat-grid-list>
                    <div *ngFor="let rewnew of rewval?.windPower">

                        <mat-grid-list cols="4" rowHeight="50px">

                            <mat-grid-tile (blur)="getText($event,1,200)" (blur)="onBlurMethodWind()"
                                (keydown)="getDefVal($event)"
                                [ngClass]="{'edit_text':group.value === 'true', 'noedit_text':group.value === 'false'}"
                                attr.contenteditable="{{contentEditableWin}}" id="renewKwH" [disabled]="true">
                                {{rewnew.ratedPower}}</mat-grid-tile>
                            <mat-grid-tile id="renewHub"> {{rewnew.hubHeight}}</mat-grid-tile>
                            <mat-grid-tile [colspan]="2" id="renewWind">Wind Turbine Assumed to be installed at peak
                                height of the building</mat-grid-tile>

                        </mat-grid-list>
                    </div>
                </div>

            </div> <!--end of row div -->

        </div>
            <div class="buttonStep buttonStepWithoutWizard">

                <button (click)="clickMeBack()" class="backTop" mat-raised-button color="default">Back</button>
                <button (click)="clickMeBack()" class="back Ren" mat-raised-button color="default">Back</button>
                <button (click)="clickMeForward()" class="nextStepBotRenew" mat-raised-button
                    color="primary">Next</button>
                <button (click)="clickMeForward()" class="nextStepTop" mat-raised-button color="primary">Next</button>
            </div>
        </div>
    </mat-tab>


    <mat-tab label="Design Variables" [disabled]="isUpdated===true || isLoading==true">

        <div class="matContent">

            <!-- Design Variables placeholder data<br/>
          test data for Design Variables test data for renewables test data for Design -->
            <mat-tab-group id="innTab" (selectedTabChange)="checkonlylight($event)"
                class="matTab designvariable for-variables-screan"
                (selectedIndexChange)="NewselectedIndexChange($event)" [selectedIndex]="newselectedIndex">
                <mat-tab class="tab-building-envelope" label="Building Envelop">
                    <!-- <button class="btnleft" (click)="uploadBuildingEnvelop()">update changes on Building Envelop</button> -->
                    <div class="tabBody_bldngenv">
                        <div class="tabInnerBody">
                        <div class="row">
                            <!-- WALL TABLE -->

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">WALL</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"> <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
												  color="primary" [checked]="isCheckedWall()" (click)="$event.stopPropagation()"
                                                   (change)="$event ? toggleAll($event) : null" id="wallCheck">
												</mat-checkbox></th>
                                                <th class="text-center">R-Value (IP)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="wallId" *ngFor="let folder of buildEnv?.projLists| slice:0:4 ">
                                                <td *ngIf="folder.wall" class="width-30"> 
                                                    <mat-checkbox #wallInput *ngIf="folder.wall" id="wallCheck1" 
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" 
                                                        [checked]="existsWall(folder,$event) || newEmail == 'demo@ecomatrix.io'"
                                                        [value]="folder.wall_r_value_ip" (change)="checkValNewWall(folder,$event) "
                                                        
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="col text-center align-middle"
                                                    *ngIf="folder.wall">{{folder.wall_r_value_ip}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            <!-- ROOF TABLE -->

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">ROOF</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"><mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedRoof()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="roofCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">R-Value (IP)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="roofitem" *ngFor="let folder of buildEnv?.projLists | slice:0:3">
                                                <td class="width-30" *ngIf="folder.roof"> 
                                                    <mat-checkbox *ngIf="folder.roof" id="roofCheck1" #roofInput
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsRoof(folder,$event)"
                                                        [value]="folder.roof_r_value_ip" (change)="checkValNewRoof(folder,$event)"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="col text-center align-middle"
                                                    *ngIf="folder.roof">{{folder.roof_r_value_ip}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            <!-- FLOOR TABLE -->
                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">{{custName === ''? 'FLOOR' : custName}}</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"><mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedFloor()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="floorCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">R-Value (IP)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="flooritem" *ngFor="let folder of buildEnv?.projLists | slice:0:2">
                                                <td class="width-30" *ngIf="folder.floor"> 
                                                    <mat-checkbox *ngIf="folder.floor"  id="floorCheck1" (click)="$event.stopPropagation()"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsFloor(folder,$event)" #floorInput
                                                        [value]="folder.floor_r_value_ip" (change)="checkValNewFloor(folder,$event)"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="col text-center align-middle"
                                                    *ngIf="folder.floor">{{folder.floor_r_value_ip}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            <!-- WINDOW TABLE -->

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th colspan="2" class="text-center">WINDOW</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30">
                                                  <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                  color="primary" [checked]="isCheckedwin()" (click)="$event.stopPropagation()"
                                                   (change)="$event ? toggleAll($event) : null" id="winCheck">
                                                </mat-checkbox>
                                                </th>
                                                 
                                                <th class="text-center">R-Value (IP)</th>
                                                <th class="text-center">SHGC</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="windowitem" *ngFor="let folder of buildEnv?.projLists | slice:0:6">
                                                <!--Phase 2.3 -->
                                                <td  *ngIf="folder.windows" class="width-30"> 
                                                        <mat-checkbox *ngIf="folder.windows"  id="winCheck1" (click)="$event.stopPropagation()"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsWin(folder,$event)" #windowInput
                                                        [value]="folder.win_r_value_ip" (change)="checkValNewWindow(folder,$event)"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="text-center align-middle" *ngIf="folder.windows">{{folder.win_r_value_ip_ref }}</td>
                                                <td class="text-center align-middle" *ngIf="folder.windows">{{folder.win_shgc }}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            <!-- Shading Table -->

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered wizardTableWidth">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th  class="text-center">SHADING</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"> <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedShad()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="shadCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">Yes/No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="shadingitem" *ngFor="let folder of buildEnv?.projLists | slice:0:2">
                                                <td class="width-30" *ngIf="folder.shading"> <mat-checkbox *ngIf="folder.shading"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsShad(folder,$event)" [value]="folder.shading"  id="shadCheck1" (click)="$event.stopPropagation()"
                                                        (change)="checkValShading(folder,$event)" #shdInput
                                                        ></mat-checkbox></td>
                                                <td class="col text-center align-middle" 
                                                    *ngIf="folder.shading">{{folder.shading}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            <!-- WWR Table-->
                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered wizardTableWidth">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">WWR</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"><mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedWwr()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="wwrCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="wwr" *ngFor="let folder of buildEnv?.projLists | slice:0:3">
                                                <td class="width-30" *ngIf="folder.wwr_percentage"> <mat-checkbox
                                                        *ngIf="folder.wwr_percentage"  id="wwrCheck1" (click)="$event.stopPropagation()"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsWwr(folder,$event)" #wwrInput
                                                        [value]="folder.wwr_percentage"
                                                        (change)="checkValwwr(folder,$event)"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="col text-center align-middle"
                                                    *ngIf="folder.wwr_percentage">{{folder.wwr_percentage}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>


                        </div>
                    </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="d-flex align-items-center ml-1 mb-2">
                                    <mat-checkbox [disabled]="true" [checked]="true"></mat-checkbox>
                                    <div class="font-10"> Create Custom Baseline </div>
                                    <div class="demomsg" *ngIf="newEmail == 'demo@ecomatrix.io'">Custom baseline is
                                        disabled
                                        for
                                        demo</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered  wizardTableWidth">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center" (change)="custBase()"
                                                        [(ngModel)]="selectedCustBase" id="Ultra" 
                                                        *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selct" selected="selectedCustBase" disabled>Select Wall
                                                        </option>
                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:4"
                                                            [value]="folder.wall" selected="selectedCustBase">
                                                            {{folder.wall_r_value_ip}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered  wizardTableWidth">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseRoof" id="Ultratwo"
                                                        (change)="CustBaseRoof()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctroof" selected="selectedCustBaseRoof" disabled>Select
                                                            Roof</option>

                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:3"
                                                            [value]="folder.roof" selected="selectedCustBaseRoof">
                                                            {{folder.roof_r_value_ip}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered  wizardTableWidth">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseFloor" id="Ultrathree"
                                                        (change)="CustBaseFloor()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctfloor" selected="selectedCustBaseFloor" disabled>
                                                            Select Floor</option>

                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:2"
                                                            [value]="folder.floor" selected="selectedCustBaseFloor">
                                                            {{folder.floor_r_value_ip}}</option>

                                                    </select>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered ">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBasewin" id="UltraFour"
                                                        (change)="CustBaseWindow()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctWin" selected="selectedCustBasewin" disabled>Select
                                                            Window</option>

                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:6"
                                                            [value]="folder.windows" selected="selectedCustBasewin">
                                                            {{folder.win_r_value_ip}}
                                                        </option>

                                                    </select>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered  wizardTableWidth">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseShading" id="UltraFive"
                                                        (change)="CustBaseShading()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctShading" selected="selectedCustBaseShading" disabled>
                                                            Select Shading</option>

                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:2"
                                                            [value]="folder.shading" selected="selectedCustBaseShading">
                                                            {{folder.shading}}</option>

                                                    </select>


                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-2 pl-2 pr-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered  wizardTableWidth">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseWWR" id="UltraSix"
                                                        (change)="CustBaseWwr()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'" >
                                                        <option value="selctrWWR" selected="selectedCustBaseWWR" disabled>Select
                                                            WWR</option>

                                                        <option *ngFor="let folder of buildEnv?.projLists | slice:0:3"
                                                            [value]="folder.wwr_percentage"
                                                            selected="selectedCustBaseWWR">
                                                            {{folder.wwr_percentage}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <!--  -->
                        <div class="d-flex solar-cutomline">
                            <div id="solarText" class="mr-2" *ngIf="contentEditableRen">Solar PV - Turned ON | </div>
                            <div id="solarText" class="mr-2" *ngIf="!contentEditableRen">Solar PV - Turned OFF | </div>
                            <div id="windText" class="mr-2" *ngIf="contentEditableWin">Wind Power - Turned ON | </div>
                            <div id="windText" class="mr-2" *ngIf="!contentEditableWin">Wind Power - Turned OFF | </div>
                            <div id="DhwText" class="mr-2" *ngIf="contentEditableHw">Domestic Hot Water - Turned ON
                            </div>
                            <div id="DhwText" class="mr-2" *ngIf="!contentEditableHw">Domestic Hot Water - Turned OFF
                            </div>
                        </div>
                        



                        <div class="buttonStep">
                            <button (click)="clickMeBack()" class="back" mat-raised-button color="default">Back</button>
                            <button (click)="clickMeBack()" class="backTop" mat-raised-button
                                color="default">Back</button>

                            <button (click)="clickMeSubForwardNext()" class="nextStepBot mt-0" mat-raised-button color="primary">Next</button>
                            <button (click)="clickMeSubForwardNext()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>

                            <!-- Building envelop end -->
                        </div>
                    </div>
                   
                    <div id="crcubline">
                       
                    </div>


                </mat-tab>
                <mat-tab label="Infiltration">
                    <div class="tabBody">
                        <div class="tabInnerBody">
                        <div class="row">
                            <!-- WALL TABLE -->

                            <div class="col-md-2">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">INFILTRATION</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"><mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedInf()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="infCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">l/s/m2(facade)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="infitem" *ngFor="let folder of infData?.projLists  | slice:0:3">
                                                <!-- Phase 2.3 -->
                                                <td class="width-30" *ngIf="folder.inf"> <mat-checkbox *ngIf="folder.inf"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        id="infCheck1" (click)="$event.stopPropagation()" 
                                                        [checked]="existsInf(folder,$event)" [value]="folder.infiltration_ref"
                                                        (change)="checkValInf(folder,$event)"  #infInput
                                                        ></mat-checkbox></td>
                                                    <!-- <td class="width-30" *ngIf="folder.inf"> <mat-checkbox *ngIf="folder.inf"
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="existsInf(folder,$event)" [value]="folder.inf"
                                                        (change)="checkValInf()"
                                                        ></mat-checkbox></td> -->
                                                <td class="col text-center" id="pp" *ngIf="folder.inf">{{folder.inf_val}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        </div>

                        <div class="row">
                            <!-- WALL TABLE -->

                            <div class="col-md-2">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                       
                                        <tbody>
                                            <tr>
                                                <td colspan="2">
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseInf" id="UltraInf"
                                                        *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctInf" selected="selectedCustBaseInf" disabled>Select
                                                            Infiltration</option>
                                                        <option *ngFor="let folder of infData?.projLists | slice:0:3"
                                                            [value]="folder.inf" selected="selectedCustBaseInf">
                                                            {{folder.inf_val}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                       
                        <div class="buttonStep">

                            <button (click)="clickMeSubBack()" class="back backTop" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubBack()" class="back backLt" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubForward()" class="nextStepBotLt" mat-raised-button
                                color="primary">Next</button>
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>

                        </div>
                    </div>
                    
                </mat-tab>
                <mat-tab label="Lighting" (selectChange)="checkValLighting()">

                    <div class="tabBody">
                        <div class="tabInnerBody">
                        <div class="row">
                            <!-- WALL TABLE -->

                            <div class="col-md-2">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered ">
                                        <thead>
                                            <tr>
                                                <th colspan="2" class="text-center">LIGHTING</th>
                                            </tr>
                                            <tr>
                                                <th colspan="2" class="text-center">LPD (w/m2)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="lightingitem">
                                                <td class="col text-center padding-11">Proposed Lighting
                                                </td>
                                                <td class="col text-center padding-11">{{proposedLight}}</td>
                                            </tr>
                                            <tr id="lightingitem">
                                                <td class="col text-center padding-11">Reference Lighting
                                                </td>
                                                <td class="col text-center padding-11"> {{refLight}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="table-responsive">
                                    <table id="daylight" class="w-100 table table-bordered ">
                                        <thead>
                                            <tr>
                                                <th class="width-30"></th>
                                                <th class="text-center">DAYLIGHT SENSOR</th>
                                            </tr>
                                            <tr>
                                                <th class="width-30"> <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                    color="primary" [checked]="isCheckedDls()" (click)="$event.stopPropagation()"
                                                     (change)="$event ? toggleAll($event) : null" id="dlsCheck">
                                                  </mat-checkbox></th>
                                                <th class="text-center">Yes/ No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="lightingitemsen"
                                                *ngFor="let folder of lightData?.projLists">
                                                <td class="width-30" *ngIf="folder.daylight_sensor">
                                                    <mat-checkbox *ngIf="folder.daylight_sensor" 
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        id="dlsCheck1" (click)="$event.stopPropagation()" #dlsInput
                                                        [checked]="existsDls(folder,$event)" [value]="folder.daylight_sensor"
                                                        (change)="checkValDls(folder,$event)"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="col text-center" *ngIf="folder.daylight_sensor">
                                                    {{folder.daylight_sensor}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        </div>

                        <div class="row">
                            <!-- WALL TABLE -->

                            <div class="col-md-2">
                                <div class="table-responsive">
                                   
                                    <table class="w-100 table table-bordered ">
                                        <tbody>
                                            <tr>
                                                <td colspan="2">
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="selectedCustBaseLight" id="UltraSeven"
                                                        (change)="CustBaseLighting()" *ngIf='contentEditable' disabled>
                                                        <option value="selctLight" selected="selectedCustBaseLight">
                                                            Select Lighting</option>
                                                        <option *ngFor="let folder of lightData?.projLists"
                                                            [value]="folder.lpd" selected="selectedCustBaseLight">
                                                            {{folder.lpd_val}} w/m2</option>
                                                            
                                                    </select>
                                                    
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="table-responsive">
                                    <table id="daylight" class="w-100 table table-bordered ">
                                        <tbody>
                                            <tr>
                                                <td colspan="2">
                                                    <select class="w-100 removeBorderSelect text-center" [(ngModel)]="selectedCustBaseDaylight"  id="UltraEight"  (change)="CustBaseDaylight()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                        <option value="selctDaylight" selected="selectedCustBaseDaylight" disabled>Select Daylight</option>
                                                        <option *ngFor="let folder of lightData?.projLists|slice : 0:2" [value]="folder.daylight_sensor" selected="selectedCustBaseDaylight">{{folder.daylight_sensor}}</option>
                                                        
                                                      </select> 


                                                    
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                       
                        <div class="buttonStep">
                            <button (click)="clickMeSubBack()" class="back backTop mr-1" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubBack()" class="back backLt mr-1" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubForwardLighting()" class="nextStepBotLt" mat-raised-button
                                color="primary">Next</button>
                            <button (click)="clickMeSubForwardLighting()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>


                        </div>

                        <div id="cuslineLight">
                            

                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="HVAC AREA1">
                    <div class="tabBody">
                        <div class="tabInnerBody">
                        <div class="hvacArea">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered ">
                                            <thead class="table-height">
                                                <tr>
                                                    <th class="width-10 remove-right-border"></th>
                                                    <th class="width-15 remove-left-border remove-right-border"></th>
                                                    <th class="width-40 text-center remove-right-border remove-left-border">HVAC AREA 1 - PRIMARY HVAC
                                                        SYSTEM</th>
                                                    <th class="text-center remove-right-border remove-left-border">
                                                    </th>
                                                    <th class="text-center remove-left-border">
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <th class="text-center width-10"><mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        color="primary" [checked]="isCheckedHvac()" (click)="$event.stopPropagation()"
                                                         (change)="$event ? toggleAll($event) : null" id="hvacCheck">
                                                      </mat-checkbox></th>
                                                    <th class="text-center width-15">System Tag</th>
                                                    <th class="text-center width-40">System Description</th>
                                                    <th class="text-center">Main Heating Fuel Source</th>
                                                    <th class="text-center">Backup Heating Fuel Source</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr id="hvacitem" *ngFor="let folder of hvDataPrimary">
                                                    <td class="width-10">
                                                        <mat-checkbox
                                                            [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                            [checked]="existsHvac(folder,$event)" #hvacInput
                                                            [value]="folder.HVAC_system"  id="hvacCheck1" (click)="$event.stopPropagation()"
                                                            (change)="checkValHvac(folder,$event)"
                                                            ></mat-checkbox>
                                                    </td>
                                                    <td class="text-center width-15" id="btnnew-{{folder.HVAC_system}}"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.active_hvac_system_id}}</td>
                                                    <td class="text-center width-40 ellipsis text-ellipsis" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.HVAC_system}}
                                                    </td>
                                                    <td class="text-center" id="btn-{{folder.HVAC_system}}"
                                                        (click)="getId(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,10)"
                                                        (blur)="toggleMe(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.mainHtgFuelSrc}}
                                                    </td>
                                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.bkupHtgFuelSrc}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered ">
                                            <thead class="table-height">
                                                <tr>
                                                    <th class="width-10 remove-right-border"></th>
                                                    <th class="width-15 remove-right-border"></th>
                                                    <th colspan="5" class="text-center">HVAC AREA 1 - FRESH AIR SYSTEM
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <th class="width-10 text-center"></th>
                                                    <th colspan="3" class="text-center">
                                                  <mat-checkbox  [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
												    color="primary" (click)="$event.stopPropagation()" [checked]="existsHeatRec('Y')" 
                                                    (change)="checkValHeatRec('Y',$event)" id="heatRecCheck"  value='Y'>
                                                    </mat-checkbox>
                                                    Heating Recovery Yes</th>
                                                    <th colspan="2" class="text-center">
                                                    <mat-checkbox  [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
												    color="primary" (click)="$event.stopPropagation()" [checked]="existsHeatRec('N')" 
                                                    (change)="checkValHeatRec('N',$event)" id="heatRecCheck"  value='N'>
                                                    </mat-checkbox>
                                                    Heating Recovery No</th> 
                                                    <th class="text-center width-30"></th>
                                                </tr>
                                                <tr>
                                                    <th class="width-10 text-center"><mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="isCheckedHeat()" #heatInput
                                                        id="heatCheck" (click)="$event.stopPropagation()"
                                                        (change)="$event ? toggleAll($event) : null"
                                                        ></mat-checkbox></th>
                                                    <th class="text-center width-15">System Tag</th>
                                                    <th class="text-center">Heating Eff</th>
                                                    <th class="text-center">Cooling Eff</th>
                                                    <th class="text-center">Heating Eff</th>
                                                    <th class="text-center">Cooling Eff</th>
                                                    <th class="text-center width-30">Main Heating Fuel Source</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="faitem1" *ngFor="let folder of freshAirPrim">
                                                    <td class="text-center width-10">
                                                    </td>
                                                    <td class="text-center width-15" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.active_hvac_system_id }}</td>
                                                    <td class="text-center" (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.ERVY_Heating_Effectiveness
                                                        }}</td>
                                                    <td class="text-center" id="btn-{{folder.HVAC_system}}"
                                                        (click)="getId(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,10)"
                                                        (blur)="toggleMe(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.ERVY_Cooling_Effectiveness }}</td>
                                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.ERVN_Heating_Effectiveness }}</td>
                                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.ERVN_Cooling_Effectiveness }}</td>
                                                    <td class="text-center width-30" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.htg_fuel_src
                                                        }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>




                            <!-- end of HVAC section -->
                            <div class="clearfix"></div>

                        </div>
                        </div>



                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered ">
                                        <tbody>
                                            <tr>
                                                <td class="width-10"></td>
                                                <td class="text-center width-15">{{selectedCustBaseHvac}}</td>
                                                <td class="text-center width-40">
                                                    <select class="removeBorderSelect w-100 text-center"
                                                    [(ngModel)]="selectedCustBaseHvacName" id="UltraNine"
                                                    (change)="CustBaseHvac()" *ngIf='contentEditable' [disabled]="newEmail == 'demo@ecomatrix.io'">
                                                   
                                                    <option *ngFor="let folder of hvDataPrimary"
                                                        [value]="folder.HVAC_system"
                                                        selected="selectedCustBaseHvacName">
                                                        {{folder.HVAC_system}}
                                                    </option>

                                                </select></td>
                                                <td class="text-center">{{mainHtgFuelSrc}}</td>
                                                <td class="text-center">{{bkupHtgFuelSrc}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                           
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered ">
                                        <tbody>
                                            <tr>
                                               
                                                <th colspan="3" class="text-center">
                                                    <input id="yes" type="radio" (change)="custBaseHeat('Y')" [(ngModel)]="newcustHtRec"
                                                    name="custom" value="Y" [disabled]="newEmail == 'demo@ecomatrix.io'"><span class="fontCls" checked>Heating Recovery Yes</span>

                                                </th>

                                                <th class="text-center" colspan="4"><input id="no" type="radio" (change)="custBaseHeat('N')"
                                                    [(ngModel)]="newcustHtRec" name="custom" value="N" [disabled]="newEmail == 'demo@ecomatrix.io'"><span class="fontCls"> Heating Recovery No</span></th>
                                                   
                                            </tr>
                                            <tr>
                                                <td class="width-10"></td>
                                                <td class="text-center width-15">{{selectedCustBaseHvac}}</td>
                                                <td class="text-center">
                                                    {{heatCbPrim}}    
                                                </td>
                                                <td class="text-center">{{coolCbPrim}}</td>
                                                <td class="text-center">{{heatCOPPrim}}</td>
                                                <td class="text-center">{{coolCOPPrim}}</td>
                                                <td class="text-center">{{fuelSrcPrim}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                       <div class="buttonStep">

                            <button (click)="clickMeSubBack()" class="back backTop" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubBack()" class="back" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubForward()" class="nextStepBot" mat-raised-button
                                color="primary">Next</button>
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>
                        </div>
                    </div>
                </mat-tab>

                <!--Tab for fresh air -->
                <mat-tab label="HVAC AREA2">

                    <div class="d-none">
                        <table class="table table-bordered ">
                            <thead>
                                <tr>
                                    <th class="width-10"></th>
                                    <th colspan="5" class="text-center">HVAC AREA 1 - PRIMARY HVAC SYSTEM</th>

                                </tr>
                                <tr>
                                    <th class="width-10"></th>
                                    <th class="text-center">System Tag</th>
                                    <th class="text-center">System Description</th>
                                    <th class="text-center">Main Heating Fuel Source</th>
                                    <th class="text-center">Backup Heating Fuel Source</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr id="hvacitem" *ngFor="let folder of hvDataPrimary">
                                    <td class="text-center width-10">
                                        <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                            [checked]="message.includes(folder.HVAC_system)" 
                                            [value]="folder.HVAC_system" (change)="checkValHvac()"
                                            ></mat-checkbox>
                                    </td>
                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}" (blur)="getText($event,0.5,8)"
                                        (blur)="getHvac(folder.HVAC_system)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.active_hvac_system_id}}</td>
                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}" (click)="getIdfirst(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.HVAC_system}}
                                    </td>
                                    <td class="text-center" id="btn-{{folder.HVAC_system}}" (click)="getId(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,10)" (blur)="toggleMe(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.mainHtgFuelSrc}}
                                    </td>
                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}" (click)="getIdfirst(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.bkupHtgFuelSrc}}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th class="text-center width-10"></th>
                                    <th class="text-center">{{selectedCustBaseHvac}}</th>
                                    <th class="text-center"> <select [(ngModel)]="selectedCustBaseHvacName" id="UltraNine"
                                            (change)="CustBaseHvac()" *ngIf='contentEditable' disabled>
                                            <option value="selctHvac" selected="selectedCustBaseHvacName">Select HVAC
                                            </option>
                                            <option *ngFor="let folder of hvDataPrimary"
                                                [value]="folder.HVAC_system" selected="selectedCustBaseHvacName">
                                                {{folder.HVAC_system}}</option>

                                        </select></th>
                                    <th class="text-center">{{mainHtgFuelSrc}}</th>
                                    <th class="text-center">{{bkupHtgFuelSrc}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="tabBody">
                        <div class="tabInnerBody">
                        <div class="hvacArea">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered ">
                                            <thead class="table-height">
                                                <tr>
                                                    <th class="width-10 remove-right-border"></th>
                                                    <th class="width-15 remove-left-border remove-right-border"></th>
                                                    <th class="width-40 remove-left-border remove-right-border text-center">HVAC AREA 2 - PRIMARY HVAC
                                                        SYSTEM</th>
                                                    <th class="text-center remove-left-border"></th>

                                                </tr>
                                                <tr rowspan="2">
                                                    <th class="width-10"></th>
                                                    <th class="text-center width-15">System Tag</th>
                                                    <th class="text-center width-40">System Description</th>
                                                    <th class="text-center">Main Heating Fuel Source</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="hvacitemSec" *ngFor="let folder of hvDataSec">
                                                    <td class="width-10">
                                                        <mat-checkbox
                                                            [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                            [checked]="true"
                                                            [value]="folder.HVAC_system" [disabled]="true"
                                                            ></mat-checkbox>
                                                    </td>
                                                    <td class="text-center width-15" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.active_hvac_system_id }}</td>
                                                    <td class="text-center width-40" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.HVAC_system
                                                        }}
                                                    </td>
                                                    <td class="text-center" id="btn-{{folder.HVAC_system}}"
                                                        (click)="getId(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,10)"
                                                        (blur)="toggleMe(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.mainHtgFuelSrc
                                                        }}
                                                    </td>

                                                </tr>
                                            </tbody>
                                           
                                        </table>
                                    </div>

                                </div>
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered ">
                                            <thead class="table-height">
                                                <tr>
                                                    <th class="width-10 remove-right-border"></th>
                                                    <th></th>
                                                    <th class="width-40 text-center remove-left-border">HVAC AREA 2 - FRESH AIR SYSTEM</th>
                                                    <th  colspan="3"></th>

                                                </tr>
                                                <tr>
                                                    <th class="width-10"></th>
                                                    <th></th>
                                                    <th class="width-40"></th>
                                                    <th colspan="2" class="text-center">HEAT RECOVERY</th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th class="width-10"></th>
                                                    <th class="text-center">System Tag</th>
                                                    <th class="text-center width-40">System Description</th>
                                                    <th class="text-center">Heating Eff</th>
                                                    <th class="text-center">Cooling Eff</th>
                                                    <th class="text-center">Main Heating Fuel Source</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="faitem2" *ngFor="let folder of freshAirSec">
                                                    <td class="width-10"><mat-checkbox
                                                            [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                            *ngIf="folder.baseline !== null" [checked]="true"
                                                            [value]="folder.baseline" [disabled]="true"
                                                            ></mat-checkbox>
                                                    </td>
                                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.active_hvac_system_id}}</td>
                                                    <td class="text-center width-40" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.freshAir_system }}</td>
                                                    <td class="text-center " id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">{{folder.heat}}
                                                    </td>
                                                    <td class="text-center" id="btn-{{folder.HVAC_system}}"
                                                        (click)="getId(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,10)"
                                                        (blur)="toggleMe(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.cool }}</td>
                                                    <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                        (click)="getIdfirst(folder.HVAC_system)"
                                                        (blur)="getText($event,0.5,8)"
                                                        (blur)="getHvac(folder.HVAC_system)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contentEditableHvac}}">
                                                        {{folder.htg_fuel_src
                                                        }}</td>
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    </div>
                                </div>
                            </div>


                            
                        </div>
                    </div>

                        <div class="row">
                            <div class="col-md-6">
                                <table class="table table-bordered ">
                                    <tbody>
                                        <tr>
                                            <td class="width-10"></td>
                                            <td class="text-center width-15">{{selectedCustBaseHvacSec}}</td>
                                            <td class="text-center width-40"> 
                                                <select class="removeBorderSelect w-100 text-center" [(ngModel)]="selectedCustBaseHvacSecName"  id="UltraNine1"  (change)="CustBaseHvac()" *ngIf='contentEditable' disabled>
                                                    <option value="selctHvac" selected="selectedCustBaseHvacSecName">Select HVAC</option>
                                                    <option *ngFor="let folder of hvData?.projLists" [value]="folder.HVAC_system" selected="selectedCustBaseHvacSecName">{{folder.HVAC_system}}</option>
                                                    
                                                  </select>    
                                            </td>
                                            <td class="text-center">{{mainHtgFuelSrc}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <table class="table table-bordered ">
                                    <tbody>
                                        <tr>
                                            <td class="text-center width-10"></td>
                                                    <td class="text-center ">{{selectedCustBaseHvacSec}}</td>
                                                    <td class="text-center width-40">
                                                        <select class="removeBorderSelect w-100 text-center" [(ngModel)]="selectedCustBaseHvacSec"
                                                            id="UltraNine1" *ngIf='contentEditable' disabled>
                                                            <option value="selctHvac"
                                                                selected="selectedCustBaseHvacSec">
                                                                Select HVAC</option>
                                                            <option *ngFor="let folder of freshAirSec"
                                                                [value]="folder.active_hvac_system_id"
                                                                selected="selectedCustBaseHvacSec">
                                                                {{folder.freshAir_system}}</option>

                                                        </select></td>
                                                    <td class="text-center">{{heatCbSec}}</td>
                                                    <td class="text-center">{{coolCbSec}}</td>
                                                    <td class="text-center">{{fuelSrcSec}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>



                       
                        <div class="buttonStep">

                            <button (click)="clickMeSubBack()" class="back backTop" mat-raised-button
                                color="default">Back</button>
                            <button (click)="clickMeSubBack()" class="back" mat-raised-button
                                color="default">Back</button>

                            <button (click)="clickMeSubForward()" class="nextStepBot" mat-raised-button
                                color="primary">Next</button>
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>

                        </div>
                    </div>
                </mat-tab>
				<mat-tab label="Humidification / Process">
				<div class="d-none">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="width-10"></th>
                                    <th colspan="4" class="text-center">HVAC AREA 2 - PRIMARY HVAC SYSTEM</th>
                                </tr>
                                <tr>
                                    <th class="width-10"></th>
                                    <th>System Tag</th>
                                    <th>System Description</th>
                                    <th>Main Heating Fuel Source</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr id="hvacitemSec"  *ngFor="let folder of hvDataSec">
                                    <td class="width-10">
                                        <mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                            [checked]="message.includes(folder.HVAC_system)"
                                            [value]="folder.HVAC_system" [disabled]="true"
                                            ></mat-checkbox>
                                    </td>
                                    <td id="btnnew-{{folder.HVAC_system}}" (click)="getIdfirst(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.active_hvac_system_id }}</td>
                                    <td id="btnnew-{{folder.HVAC_system}}" (click)="getIdfirst(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.HVAC_system
                                        }}
                                    </td>
                                    <td id="btn-{{folder.HVAC_system}}" (click)="getId(folder.HVAC_system)"
                                        (blur)="getText($event,0.5,10)" (blur)="toggleMe(folder.HVAC_system)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
                                        {{folder.mainHtgFuelSrc
                                        }}
                                    </td>

                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th>{{selectedCustBaseHvac}}</th>
                                    <th> <select class="w-100" [(ngModel)]="selectedCustBaseHvacName" id="UltraNine"
                                            (change)="CustBaseHvac()" *ngIf='contentEditable' disabled>
                                            <option value="selctHvac" selected="selectedCustBaseHvacName">Select HVAC
                                            </option>
                                            <option *ngFor="let folder of hvData?.projLists"
                                                [value]="folder.HVAC_system" selected="selectedCustBaseHvacName">
                                                {{folder.HVAC_system}}</option>

                                        </select></th>
                                    <th>{{mainHtgFuelSrc}}</th>
                                </tr>
                            </tfoot>
                        </table>
                 </div>
				 <div class="matContentDHW tabBody">
                    <div class="tabInnerBody">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th class="width-10"></th>
												<th colspan="4" class="text-center">Humidification / Process</th>
											</tr>
											<tr>
												<th class="width-10"></th>
												<th class="text-center">System Tag</th>
												<th class="text-center">Availability</th>
												<th class="text-center">Efficiency</th>
												<th class="text-center">Fuel Source</th>
											</tr>
										</thead>
										<tbody>

											<tr id="hum" *ngFor="let folder of humidification">
												<td class="width-10">
													<mat-checkbox [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
														[checked]="contentEditable"
														[value]="folder.HVAC_system" [disabled]="true"
														></mat-checkbox>
												</td>
												<td [value]="folder.hvac_system_id" class="text-center">
													{{folder.hvac_system_id}}</td>
												<td id="btnnew-{{folder.hvac_system_id}}"  class="text-center" (click)="getIdfirst(folder.hvac_system_id)"
													(blur)="getText($event,0.5,8)" (blur)="getHvac(folder.hvac_system_id)"
													(keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
													{{folder.hum_avlbl}}</td>
												<td id="btn-{{folder.hvac_system_id}}"  class="text-center" (click)="getId(folder.hvac_system_id)"
													(blur)="getText($event,0.5,10)" (blur)="toggleMe(folder.hvac_system_id)"
													(keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
													{{folder.hum_avlbl==='Y'? folder.hum_eff : '-'
													}}
												</td>
												<td id="btn-{{folder.hvac_system_id}}"  class="text-center" (click)="getId(folder.hvac_system_id)"
													(blur)="getText($event,0.5,10)" (blur)="toggleMe(folder.hvac_system_id)"
													(keydown)="getDefVal($event)" attr.contenteditable="{{contentEditableHvac}}">
													{{folder.hum_avlbl==='Y'? folder.hum_fuel_source : '-'
													}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						</div>
						<div class="row">
                        <div class="col-md-6">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td class="width-10"></td>
                                            <td class="text-center">{{selectedCustBaseHvac}}</td>
                                            <td class="text-center">{{humAvlbl}}</td>
                                            <td class="text-center">{{humAvlbl==='Y'?humCost:'-'}}</td>
											<td class="text-center">{{humAvlbl==='Y'?humFuelSourceCust:'-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>   
                        </div>
                    </div>
					<div class="buttonStep">
                            <button (click)="clickMeSubBack()" class="back" mat-raised-button color="default">Back</button>
                            <button (click)="clickMeSubBack()" class="backTop" mat-raised-button
                                color="default">Back</button>

                            <button (click)="clickMeSubForward()" class="nextStepBot mt-0" mat-raised-button color="primary">Next</button>
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>

                            
                        </div>
                </div>
                </mat-tab> 
                <mat-tab label="Domestic Hot Water">

                    

                    <div class="matContentDHW tabBody">
                        <div class="tabInnerBody">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-10"></th>
                                                <th colspan="3" class="text-center">DOMESTIC HOT WATER SYSTEM</th>
                                            </tr>
                                            <tr>
                                                <th class="width-10"></th>
                                                <th class="text-center">System Tag</th>
                                                <th class="text-center">System Efficiency</th>
                                                <th class="text-center">Main Heating Fuel Source</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let folder of freshAir?.DHW">
                                                <td class="width-10"> <mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="true"
                                                        [value]="folder.HVAC_system" (change)="checkValHvac()" [disabled]="true"
                                                        ></mat-checkbox>
                                                </td>
                                                <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                    (click)="getIdfirst(folder.HVAC_system)"
                                                    (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contentEditableHvac}}">
                                                    {{folder.active_hvac_system_id }}</td>
                                                <td class="text-center" id="btnnew-{{folder.HVAC_system}}"
                                                    (click)="getIdfirst(folder.HVAC_system)"
                                                    (blur)="getText($event,0.5,8)" (blur)="getHvac(folder.HVAC_system)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contentEditableHvac}}">{{folder.efficiency
                                                    }}</td>
                                                <td class="text-center" id="btn-{{folder.HVAC_system}}" (click)="getId(folder.HVAC_system)"
                                                    (blur)="getText($event,0.5,10)"
                                                    (blur)="toggleMe(folder.HVAC_system)" (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contentEditableHvac}}">
                                                    {{folder.DHWSource }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td class="width-10"></td>
                                            <td class="text-center">{{selectedCustBaseHvac}}</td>
                                            <td class="text-center">{{effCust}}</td>
                                            <td class="text-center">{{srcCust}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>   
                        </div>
                    </div>
                        <div class="buttonStep">
                            <button (click)="clickMeSubBack()" class="back" mat-raised-button
                                color="default">Back</button>
                            <button (click)="goHome()" class="nextStepBotRenew" mat-raised-button
                                color="primary">Finish</button>
                        </div>
                    </div>
                    </mat-tab>
            </mat-tab-group>



            </div>
    </mat-tab>


</mat-tab-group>